import { z } from 'zod';

export const createdIssuesNotificationMetadataSchema = z.object({
	isWeekly: z.boolean().optional(),
	issuesDescriptions: z.array(z.string()),
});

export type ICreatedIssuesNotificationMetadata = z.infer<typeof createdIssuesNotificationMetadataSchema>;
